/*
 * File: /src/router/routes/analytics.js
 * Created Date: Sunday April 25th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 25th April 2021 4:42:46 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

const AnalyticsPopups = () =>
  import(
    /* webpackChunkName: "Analytics" */ 'src/components/Dashboard/Views/Analytics/AnalyticsPopups.vue'
  );
const AnalyticsPopupDetail = () =>
  import(
    /* webpackChunkName: "Analytics" */ 'src/components/Dashboard/Views/Analytics/AnalyticsPopupDetail.vue'
  );
const AnalyticsAutomations = () =>
  import(
    /* webpackChunkName: "Analytics" */ 'src/components/Dashboard/Views/Analytics/AnalyticsAutomations.vue'
  );
const AnalyticsAutomationsDetail = () =>
  import(
    /* webpackChunkName: "Analytics" */ 'src/components/Dashboard/Views/Analytics/AnalyticsAutomationDetail.vue'
  );
const AnalyticsCalls = () =>
  import(
    /* webpackChunkName: "Analytics" */ 'src/components/Dashboard/Views/Analytics/AnalyticsCalls.vue'
  );
const AnalyticsCallDetail = () =>
  import(
    /* webpackChunkName: "Analytics" */ 'src/components/Dashboard/Views/Analytics/AnalyticsCallDetail.vue'
  );

export const analyticsRoutes = [
  {
    path: 'analytics/popups',
    name: 'Popup Reports',
    component: AnalyticsPopups
  },
  {
    path: 'analytics/popups/:id?',
    name: 'Popup Report',
    component: AnalyticsPopupDetail
  },
  {
    path: 'analytics/automations',
    name: 'Automation Reports',
    component: AnalyticsAutomations
  },
  {
    path: 'analytics/automations/:id?',
    name: 'Automation Report Detail',
    component: AnalyticsAutomationsDetail
  },
  {
    path: 'analytics/calls',
    name: 'Call Reports',
    component: AnalyticsCalls
  },
  {
    path: 'analytics/calls/:id?',
    name: 'Call Report Detail',
    component: AnalyticsCallDetail
  }
];
